'use strict';

import { Checkbox, Col, Form, Input, InputNumber, Row, Select } from 'antd';
import React from 'react';
import { getColUnitByDesc, vldCCtrlHidFlg, vldCOnChangeAndCtrlHidFlg } from 'rt-sd-dnd/sgiDndDev/Dnd_SgiFormEditorCommonUtils';
import { getExpressOptions } from './common';
import { EditorDesc } from './editorConstants';

const FormItem = Form.Item;
const Search = Input.Search;
const Option = Select.Option;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
    style: { margin: 0 }
};

const formItemLayout2 = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
    style: { margin: 0 }
};

const formItemLayout3 = {
    labelCol: { span: 12 },
    wrapperCol: { span: 12 },
    style: { margin: 0 }
};

const ctlTypes = [{
    "te": "文本框",
    "c": "EP_EO_UI_3101"
}, {
    "te": "文本域",
    "c": "EP_EO_UI_3102"
}, {
    "te": "数字",
    "c": "EP_EO_UI_3104",
}, {
    "te": "时间",
    "c": "EP_EO_UI_3105",
}, {
    "te": "日期",
    "c": "EP_EO_UI_3106",
}, {
    "te": "下拉窗",
    "c": "EP_EO_UI_3107",
}, {
    "te": "复选框组",
    "c": "EP_EO_UI_3108",
}, {
    "te": "单选框组",
    "c": "EP_EO_UI_3109",
}, {
    "te": "复选框",
    "c": "EP_EO_UI_3110",
}, {
    "te": "下拉树",
    "c": "EP_EO_NUI_0001",
}];
//let valueTypePrm = PrmFactory.getPrm(custGroupConfig.valueTypePrm) || {};
let types = [
    {
        "te": "字符串",
        "c": "01"
    },
    {
        "te": "字符串数组",
        "c": "02"
    },
    {
        "te": "数字",
        "c": "03"
    },
    {
        "te": "数字数组",
        "c": "04"
    },
    {
        "te": "小数",
        "c": "05"
    },
    {
        "te": "小数数组",
        "c": "06"
    },
    {
        "te": "日期",
        "c": "07"
    }
];
const valueTypes = types.map(type => type);


var textOnChange = (currentModule, attname, e, e2) => {
    let value = e.target.value;
    currentModule.refresh(attname, value);
}

var selectOnChange = (currentModule, attname, value) => {//change传入对象为value
    currentModule.refresh(attname, value);
}

var numberOnChange = (currentModule, attname, e) => {
    let value = e;
    currentModule.refresh(attname, value);
}

var checkOnChange = (currentModule, attname, e) => {
    let value = e.target.checked;
    currentModule.refresh(attname, value);
}

var renderSelectOptions = (data, codeCode, textCode) => {
    codeCode = codeCode || "c";
    textCode = textCode || "te";
    return data.map((item) => {
        return <Option value={item[codeCode]}>{item[textCode]}</Option>;
    });
}

var getSCEditor = (currentModule, label, attname) => {//标准代码
    label = label || "标准代码";
    attname = attname || "scId";
    return (
        <Col span={8}>
            <FormItem {...formItemLayout} label={label}>
                <Search value={currentModule.state.values[attname]} onChange={textOnChange.bind(currentModule, currentModule, attname)}
                    onSearch={() => currentModule.setState({ SCModalVisible: true })} />
            </FormItem>
        </Col>
    );
}

var getValidCol = (currentModule) => {
    if (!currentModule.state.values.vldC) {
        currentModule.state.values.vldC = ""
    }
    vldCCtrlHidFlg(currentModule, currentModule.state.values.vldC);
    return (
        <Col span={8}>
            <FormItem {...formItemLayout} label={"校验类型"}>
                <Select value={currentModule.state.values.vldC} onChange={vldCOnChangeAndCtrlHidFlg.bind(currentModule, currentModule, 'vldC')}>
                    <Option value="">无</Option>
                    <Option value="int">整数</Option>
                    <Option value="double">Double</Option>
                    <Option value="money">金额</Option>
                    <Option value="email">email</Option>
                    <Option value="idcard18">身份证</Option>
                    <Option value="phone">电话号</Option>
                    <Option value="mobile">手机号</Option>
                    <Option value="zip">邮政</Option>
                    <Option value="url">HTTP地址</Option>
                    <Option value="qq">QQ号</Option>
                    <Option value="number">数字</Option>
                    <Option value="汉字">汉字</Option>
                    <Option value="字母">字母</Option>
                </Select>
            </FormItem>
        </Col>
    );
}
var getValidRow = (currentModule) => {
    if (!currentModule.state.values.defaultMatchType) {
        currentModule.state.values.defaultMatchType = "EqualTo"
    }
    return (
        <Row>
            {getValidCol(currentModule)}
            <Col span={8}>
                <FormItem {...formItemLayout} label={"默认匹配"}>
                    <Select value={currentModule.state.values.defaultMatchType} onChange={selectOnChange.bind(currentModule, currentModule, 'defaultMatchType')}>
                        {getExpressOptions()}
                    </Select>
                </FormItem>
            </Col>
            <Col span={4}>
                <FormItem style={{ margin: 0 }} labelCol={{ span: 18 }} label={"匹配选择禁用"}>
                    <Checkbox checked={currentModule.state.values.matchDis} onChange={checkOnChange.bind(this, currentModule, 'matchDis')} />
                </FormItem>
            </Col>
        </Row >
    );
}
var getValidForm = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
        </Form>
    );
}
var getTextEidtor = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
            <Row>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"文本后信息"}>
                        <Input value={currentModule.state.values.bdText} onChange={textOnChange.bind(currentModule, currentModule, 'bdText')} />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    );
}
var getEidtorFun = (currentModule, ctlType) => {
    let ctlDescs = EditorDesc[ctlType];
    return (
        <Form>
            {getValidRow(currentModule)}
            {ctlDescs ? getRowEidtorByDesc(ctlDescs, currentModule) : null}
        </Form>
    );
}
var getRowEidtorByDesc = (rowDescs, currentModule) => (
    rowDescs.map(row => (
        <Row>
            {row.map(ctlDesc => (
                ctlDesc.code === "scId"
                    ? getSCEditor(currentModule)
                    : getColUnitByDesc(ctlDesc, currentModule)
            ))}
        </Row>
    ))
)
var getNumberEidtor = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
            <Row>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"最小长度"}>
                        <InputNumber defaultValue={0} value={currentModule.state.values.minL} onChange={numberOnChange.bind(currentModule, currentModule, 'minL')} />
                    </FormItem>
                </Col>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"最大长度"}>
                        <InputNumber defaultValue={0} value={currentModule.state.values.maxL} onChange={numberOnChange.bind(currentModule, currentModule, 'maxL')} />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    );
}
var getTimeEidtor = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
            <Row>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"时间格式"}>
                        <Input placeholder="HH:mm:ss" value={currentModule.state.values.timeFmt} onChange={textOnChange.bind(currentModule, currentModule, 'timeFmt')} />
                    </FormItem>
                </Col>
            </Row>
        </Form>

    );
}
var getDateEidtor = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
            <Row>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"日期格式"}>
                        <Input placeholder="YYYY-MM-DD" value={currentModule.state.values.dateFmt} onChange={textOnChange.bind(currentModule, currentModule, 'dateFmt')} />
                    </FormItem>
                </Col>
                {/* <Col span={8}>
                    <FormItem {...formItemLayout} label={"显示时间"}>
                        <Checkbox checked={currentModule.state.values.dateTimeFlag} onChange={checkOnChange.bind(currentModule, currentModule, 'dateTimeFlag')} />
                    </FormItem>
                </Col> */}
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"组件模式"}>
                        <Select value={currentModule.state.values.ctlMode || "date"} onChange={selectOnChange.bind(currentModule, currentModule, 'ctlMode')}>
                            <Option value="date">日期模式</Option>
                            <Option value="dateTime">日期时间模式</Option>
                            <Option value="month">月模式</Option>
                            <Option value="week">周模式</Option>
                            <Option value="dateRange">日期范围模式</Option>
                            <Option value="dateTimeRange">日期时间范围模式</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"起始日期"}>
                        <Input value={currentModule.state.values.optBDt} onChange={textOnChange.bind(currentModule, currentModule, 'optBDt')} />
                    </FormItem>
                </Col>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"结束日期"}>
                        <Input value={currentModule.state.values.optEDt} onChange={textOnChange.bind(currentModule, currentModule, 'optEDt')} />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    );
}
var getComboxEidtor = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
            <Row>
                {getSCEditor(currentModule)}
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"默认值"}>
                        <Input value={currentModule.state.values.defVal10} onChange={textOnChange.bind(currentModule, currentModule, 'defVal10')} />
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span={4}>
                    <FormItem {...formItemLayout3} label={"多选"}>
                        <Checkbox checked={currentModule.state.values.mulSel} onChange={checkOnChange.bind(currentModule, currentModule, 'mulSel')} />
                    </FormItem>
                </Col>
                <Col span={4}>
                    <FormItem {...formItemLayout3} label={"搜索框"}>
                        <Checkbox checked={currentModule.state.values.search} onChange={checkOnChange.bind(currentModule, currentModule, 'search')} />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    );
}
var getCheckboxGroupEidtor = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
            <Row>
                {getSCEditor(currentModule)}
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"默认选中项"}>
                        <Input value={currentModule.state.values.checked} onChange={textOnChange.bind(currentModule, currentModule, 'checked')} />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    );
}
var getCheckboxEidtor = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
            <Row>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"初始值"}>
                        <Input value={currentModule.state.values.defVal10} onChange={textOnChange.bind(currentModule, currentModule, 'defVal10')} />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    );
}
var getComboxTreeEidtor = (currentModule) => {
    return (
        <Form>
            {getValidRow(currentModule)}
            <Row>
                {getSCEditor(currentModule)}
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"绑定实例名"}>
                        <Input value={currentModule.state.values.insName} onChange={textOnChange.bind(currentModule, currentModule, 'insName')} />
                    </FormItem>
                </Col>
                <Col span={4}>
                    <FormItem {...formItemLayout} label={"多选"}>
                        <Checkbox checked={currentModule.state.values.mulSel} onChange={checkOnChange.bind(currentModule, currentModule, 'mulSel')} />
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"显示属性名"}>
                        <Input value={currentModule.state.values.showKey} onChange={textOnChange.bind(currentModule, currentModule, 'showKey')} />
                    </FormItem>
                </Col>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={"保存属性名"}>
                        <Input value={currentModule.state.values.saveKey} onChange={textOnChange.bind(currentModule, currentModule, 'saveKey')} />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    );
}

export { formItemLayout, formItemLayout2, formItemLayout3, ctlTypes, valueTypes, renderSelectOptions, getValidRow, getValidForm, getTextEidtor, getNumberEidtor, getTimeEidtor, getDateEidtor, getComboxEidtor, getCheckboxGroupEidtor, getCheckboxEidtor, getComboxTreeEidtor, getEidtorFun };




// WEBPACK FOOTER //
// ./apps/pages/paramMng/Constant.js